export default ".input-label{\n\n    padding: 0px !important;\n    height: 24px;\n\n}";